import { useMediaQuery, MediaQueryFeatures } from 'react-responsive';
import { breakPoint } from '@src/style/variable';

export default function useMediaQueryCustom(
  handleMediaQueryChange?: (matches: any) => void,
  device?: MediaQueryFeatures,
) {
  const isMobile = useMediaQuery(
    { maxWidth: breakPoint.mobile },
    device,
    handleMediaQueryChange,
  );

  return {
    isMobile: isMobile,
  };
}
